import React from 'react';
import Typography from '@ui/Typography';
import { Box } from '@mui/system';
import { makeStyles } from 'tss-react/mui';
import palette from '@ui/palette';
import { ModelOptionProps } from './types';
import ModelOption from './ModelOption';
import { SampleRateSubOption } from '../hooks/useProjectVersion';

export interface UniversalOptionProps
  extends Pick<ModelOptionProps, 'disabled' | 'active'> {
  options?: Array<SampleRateSubOption>;

  error?: boolean;
  isUpgrade?: boolean;
}

const useStyles = makeStyles()(theme => ({
  container: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(0.25),
  },
  titleContainer: {
    display: 'flex',
    alignItems: 'center',
    '& > button': { zIndex: 1 },
    gap: theme.spacing(0.75),
  },
  inputContainer: {
    display: 'grid',
    width: theme.spacing(19),
    gap: 10,
    '& > button': {
      color: 'inherit !important',
      '& > span > *': { color: 'inherit' },
    },
  },
  disabled: { opacity: 0.5 },
  inactive: { color: palette.gray_75 },
  active: { color: palette.gray_0 },
}));
// @todo: eventually make this option have parity with whatever ui we decide on.
const UniversalOption = ({ active, disabled }: UniversalOptionProps) => {
  const { classes, cx } = useStyles();

  return (
    <ModelOption
      variant="secondary"
      disabled={disabled}
      active={active}
      description={`Our latest Studio experience with access to all voice models, including Caruso and Standard, plus support for global languages.`}
      icon={undefined}
      title={
        <Box className={classes.container}>
          <Box className={classes.titleContainer}>
            <Typography
              id="models-label"
              variant="pMd"
              component="h3"
              bold
              className={cx({
                [classes.disabled]: disabled,
                [classes.active]: active,
                [classes.inactive]: !active,
              })}
            >
              WellSaid Studio
            </Typography>
            <Box marginLeft={0.5}>
              <Typography variant="pMd" bold color="secondary">
                (Recommended)
              </Typography>
            </Box>
          </Box>
        </Box>
      }
    />
  );
};

export default UniversalOption;
